import { Fragment } from 'react'

import cx from 'classnames'
import { m } from 'framer-motion'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import OnboardingImageScreen2 from '@/assets/images/brawlstars/onboarding-image-screen-2.png'
import BrawlFlare from '@/assets/images/storefronts/brawlstars/shop_item_bg_flare.png'
import { useLocale } from '@/features/locale/useLocale'

import { getTypographyStyles } from '../../../../../_storeBase/typography/StoreTypography'
import { animationBase, titleStyles } from '../../../constants'

import styles from './styles.module.scss'

export const Screen2 = () => {
  const t = useTranslations()
  const locale = useLocale()
  const shortSlug = 'bs'

  const titleClassnames = getTypographyStyles({
    ...titleStyles,
    locale: locale,
  })

  return (
    <Fragment>
      <m.h1
        {...animationBase}
        key="bs-screen-2-title"
        transition={{ duration: 0.2, delay: 0.3, ease: 'easeInOut' }}
        className={cx(styles.Title, titleClassnames)}
      >
        {t('onboarding_discover_specials').toUpperCase()}
      </m.h1>
      <m.div
        {...animationBase}
        key="bs-screen-2-image"
        transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
        className={styles.ItemArea}
      >
        <Image src={BrawlFlare} className={styles.flare} width={320} alt="flare" />
        <Image src={OnboardingImageScreen2} alt="" width={300} />
      </m.div>
      <m.div
        {...animationBase}
        key="bs-screen-2-footer"
        transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
        className={styles.BottomText}
      >
        <p>{t(`${shortSlug}_onboarding_specials_available`)}</p>
      </m.div>
    </Fragment>
  )
}
